// ─── Brandmark — concentric rings + hand-stamped nock crosshair
export function Brandmark() {
  return (
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="23" fill="var(--vellum)" stroke="var(--nock)" strokeWidth="1.2" />
      <circle cx="24" cy="24" r="18" fill="var(--nock)" />
      <circle cx="24" cy="24" r="13" fill="var(--field)" />
      <circle cx="24" cy="24" r="8" fill="var(--cinder)" />
      <circle cx="24" cy="24" r="4" fill="var(--gold)" />
      <path
        d="M21.5 21.2 L26.4 26.6 M26.6 21.4 L21.2 26.5"
        stroke="var(--nock)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

// ─── Wordmark — italic gold X · upright RING
export function Wordmark() {
  return (
    <div className="wordmark">
      <span className="x">X</span>
      <span className="dash">·</span>
      <span className="ring">RING</span>
    </div>
  );
}
